import React from "react"

const ChevronLeftBtn = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
    >
      <g filter="url(#filter0_b_9477_30581)">
        <rect
          width="34"
          height="34"
          rx="17"
          fill="#1C1F21"
          fillOpacity="0.48"
        />
        <path
          d="M10 17C10 17.1765 10.0294 17.3235 10.0882 17.4412C10.1471 17.5882 10.2353 17.7059 10.3529 17.8235L19.2353 26.6471C19.4706 26.8824 19.7353 27 20.0882 27C20.4118 27 20.7059 26.8824 20.9412 26.6765C21.1765 26.4412 21.2647 26.1765 21.2647 25.8235C21.2647 25.5 21.1471 25.2353 20.9118 24.9706L12.8824 17L20.9118 9.02941C21.1471 8.79412 21.2647 8.5 21.2647 8.17647C21.2647 7.85294 21.1471 7.55883 20.9412 7.32353C20.7059 7.08824 20.4412 7 20.0882 7C19.7647 7 19.4706 7.11765 19.2353 7.35294L10.3529 16.1765C10.1176 16.4118 10 16.6765 10 17Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_9477_30581"
          x="-2"
          y="-2"
          width="38"
          height="38"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="1" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_9477_30581"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_9477_30581"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default ChevronLeftBtn
